import React, { Component, PropTypes } from 'react';
import { map as _map } from 'lodash';

import './ErrorModal.css';

export default class ErrorModal extends Component {
    static propTypes = {
        error: PropTypes.object,
        clearError: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props);

        this.handleDismissClick = this.handleDismissClick.bind(this);
        this.handleDismissClick = this.handleDismissClick.bind(this);
    }

    handleDismissClick() {
        this.props.clearError();
    }

    handleReloadClick() {
        window.location.reload();
    }

    render() {
        let display = `none`;
        let messageJsx = null;
        let dismissJsx = null;
        let reloadJsx = null;

        if (this.props.error) {
            display = `flex`;
            messageJsx = _map(this.props.error.messageLines, (line, i) => {
                return (
                    <p key={`error-message-${i}`}>{line}</p>
                );
            });

            if (this.props.error.reloadText)
                reloadJsx = <span onClick={this.handleReloadClick}>{this.props.error.reloadText}</span>;

            if (this.props.error.dismissText || !this.props.error.reloadText) {
                const dismissText = this.props.error.dismissText ? this.props.error.dismissText : `CONTINUE`;
                dismissJsx = <span onClick={this.handleDismissClick}>{dismissText}</span>;
            }
        }

        return (
            <div className="modal-wrapper" style={{ display }}>
                <div className="modal error-modal">
                    <div className="errorMessage">
                      {messageJsx}
                    </div>
                    <div className="buttons">
                        {reloadJsx}
                        {dismissJsx}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Common/ErrorModal.jsx